import React from 'react'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import Link from 'next/link'
import { getArticleList_articleGraph_articleList_edges_node } from '~/graphqls/types'

const StyledSingleArticle = styled.div`
  border-radius: 16px;
  background: ${props => props.theme.light2};
  .article-bg {
    border-radius: 16px;
    height: 211px;
  }
  .article-title {
    padding: 16px;
    height: 80px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    color: ${props => props.theme.dark2};
  }
`
const WUJIEAI_HOST = process.env.NEXT_PUBLIC_WUJIEAI_HOST
export const ArticleCard: React.FC<{
  data: getArticleList_articleGraph_articleList_edges_node
  style?: React.CSSProperties
}> = ({ data, style }) => {
  return (
    <StyledSingleArticle style={style}>
      <div
        onClick={() => {
          window.open(WUJIEAI_HOST + `/article/${data?.id}`)
        }}
      >
        <a>
          <MyImage
            tag="v1200"
            className="article-bg"
            src={data?.post?.thumbnail}
          />
          <div className="article-title">
            <div className=" h-12 line-clamp-2">{data?.post?.title}</div>
          </div>
        </a>
      </div>
    </StyledSingleArticle>
  )
}
